/* eslint-disable import/no-cycle */
import isEmpty from 'lodash/isEmpty';
import { createBrowserHistory } from 'history';
// import ReactGA from 'react-ga';

import StackHandler from './StackHandler';
import GlobalStorageService from '../../../services/GlobalStorageService';
import StorageConstants from '../../../constants/StorageConstants';

const history = createBrowserHistory();
const originalGoBack = history.goBack;
const originalPush = history.push;
const originalListen = history.listen;
history.listen(location => {
  console.log({ location });
  // ReactGA.set({ page: location.pathname });
  // ReactGA.pageview(location.pathname);
});

history.originalGoBack = originalGoBack;
history.originalPush = originalPush;
history.originalListen = originalListen;

export default {
  ...history,
  ...{
    _dispatchPush(data) {
      if (!data) return;
      history.originalPush(data);
    },

    _dispatchGoBack(data) {
      console.log('_dispatchGoBack -> data', data);
      const goBackCb = this._getGoBackCb();
      if (goBackCb) {
        goBackCb();
        return;
      }
      if (isEmpty(StackHandler.popRoute())) {
        return;
      }
      history.originalGoBack();
    },

    _getGoBackCb() {
      return GlobalStorageService.getItem(StorageConstants.GO_BACK_CB);
    },
    goBack(data) {
      this._dispatchGoBack(data);
    },

    push(route, isForced) {
      // const isValidRoute = StackHandler.pushRoute(route, isForced);
      // if (isValidRoute) this._dispatchPush(route);
      this._dispatchPush(route);
    },
    setGoBackCb(cb) {
      if (!cb && typeof cb !== 'function') return;
      GlobalStorageService.setItem(StorageConstants.GO_BACK_CB, cb);
      // eslint-disable-next-line consistent-return
      return () => {
        GlobalStorageService.setItem(StorageConstants.GO_BACK_CB, undefined);
      };
    },
    getCurrentLocation() {
      return history.location;
    },
    refresh() {
      window.location.reload();
    },
    emitPopEvent() {
      window.eventemitter.emit('onGoBack', true);
    },
    listenNavigation() {
      history.originalListen((newLocation, action) => {
        if (action === 'POP') {
          this.emitPopEvent();
          StackHandler.popIfRouteMismatch(newLocation);
        }
      });
    },
    isHistoryEmpty() {
      return StackHandler.isStackEmpty();
    },
    replace(route) {
      return history.replace(route);
    },
  },
};
